import { useIsMobile } from '@noor/lib';
import type { ModalRenderProps } from '@noor/lib';
import { PromotionModalDesktop } from './promotion-modal.desktop';
import { PromotionModalMobile } from './promotion-modal.mobile';

type PromotionModalProps =
  | ModalRenderProps<'add-promotion'>
  | ModalRenderProps<'edit-promotion'>;

/**
 * Create / edit promotion, registered under `add-promotion`/`edit-promotion`.
 *
 * Picks between two distinct trees, mirroring the page-level `.mobile.tsx`
 * split (CLAUDE.md §6c): mobile is a bottom sheet whose two select fields open
 * full-screen pickers (Figma 26280:94801 → 26280:95043), not the desktop
 * dialog with its docked side panel rendered narrow. Both branches share the
 * same schema, defaults/mappers and mutation hooks — only the view differs.
 */
export function PromotionModal(props: PromotionModalProps) {
  return useIsMobile() ? (
    <PromotionModalMobile {...props} />
  ) : (
    <PromotionModalDesktop {...props} />
  );
}
